import React from "react"
import PropTypes from "prop-types"
import {useEffect} from "react"
import { useSelector, useDispatch } from "react-redux"
import { Toast } from "react-bootstrap"
import { colours } from "../../common/colours"
import {resetToast} from '../../slices/toastSlice'
import './toaster.scss'


const Toaster = () => {
  const dispatch = useDispatch()
  const toast = useSelector(state => state.toast)
  const { duration, text, type } = toast

  useEffect(()=>{
    if(duration){
      setTimeout(()=>{
        dispatch(resetToast())
      }, duration)
    }
  },[text])


  if (!text) return null

  const colors = {
    FAILED: colours.red,
    SUCCESS: colours.green
  }

  //return nothing for SSR page, in-case error was thrown
  if (typeof window === "undefined") {
    return null
  }

    return (
    <div className={'toaster'}>
      <Toast>
        <Toast.Header closeLabel={''} closeButton={false}>
          {type && <svg className="toaster__status rounded mr-2" width="20" height="20" xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="xMidYMid slice" focusable="false" role="img">
            <rect width="100%" height="100%" fill={colors[type]}></rect>
          </svg>}

          <strong className="me-auto">{text}</strong>
          {/*<small>11 mins ago</small>*/}
        </Toast.Header>
        {/*<Toast.Body>{toast.message.text}</Toast.Body>*/}
      </Toast>
    </div>
  )
}
export default Toaster
